import * as React from 'react';
import s from './LimitedTimeBanner.scss';

export const Pulsar = () => <div className={s.pulsar} />;
